import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SendPasswordResetLinkToBOUserRPC } from "./sendPasswordResetLinkToBoUserRPC";

export class SendPasswordResetLinkToBOUserRPCClientImpl extends SendPasswordResetLinkToBOUserRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SendPasswordResetLinkToBOUserRPC.Request): Promise<LeoRPCResult<SendPasswordResetLinkToBOUserRPC.Response, SendPasswordResetLinkToBOUserRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/SendPasswordResetLinkToBOUser",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SendPasswordResetLinkToBOUserRPC.ResponseDTO,
      SendPasswordResetLinkToBOUserRPC.Errors.ErrorsDTO,
      SendPasswordResetLinkToBOUserRPC.Response,
      SendPasswordResetLinkToBOUserRPC.Errors.Errors
    >(
      response,
      "bo-user-management/SendPasswordResetLinkToBOUser",
      SendPasswordResetLinkToBOUserRPC.Response.fromDTO,
      SendPasswordResetLinkToBOUserRPC.Errors.fromDTO
    );
  }
}
